export const Bio = {
  name: "Soham Mandaviya",
  roles: [
    "Software Engineer",
    "Full Stack Developer",
    "Problem Solver",
    "Competitive Programmer",
  ],
  description:
    "I am a passionate software engineer with 1.7 years of experience crafting efficient and user-friendly applications. I have completed my graduation from DA-IICT, Gandhinagar. I've been on an exciting journey of learning and growth.",
  github: "https://github.com/swa-aham",
  resume:
    "https://drive.google.com/file/d/12wH8oXT7YVV8XDfOJfR0LznnkNfqqkI3/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/soham-mandaviya/",
  leetcode: "https://leetcode.com/u/soham_mandaviya/",
  GFG: "https://www.geeksforgeeks.org/user/202001142/",
  twitter: "https://x.com/swa_aham",
  insta: "https://www.instagram.com/sva.aham/",
  facebook: "",
  email: "sohammandaviya@gmail.com",
};

export const skills = [
  {
    title: "",
    skills: [
      {
        name: "React",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Java",
        image: "https://icon.icepanel.io/Technology/svg/Java.svg",
      },
      {
        name: "Spring Boot",
        // image: "https://icon.icepanel.io/Technology/svg/Spring-Boot.svg",
        // image: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Spring_Boot.svg/512px-Spring_Boot.svg.png"
        image: "https://img.icons8.com/?size=256&id=2oBx9FpXcbLa&format=png",
      },
      {
        name: "Spring",
        // image: "https://icon.icepanel.io/Technology/svg/Spring.svg",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Spring_Boot.svg/512px-Spring_Boot.svg.png",
      },
      // {
      //   name: "Tailwind CSS",
      //   image:
      //     "https://icon.icepanel.io/Technology/svg/Tailwind-CSS.svg",
      // },
      // {
      //   name: "Bootstrap",
      //   image:
      //     "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      // },
      // {
      //   name: "Material UI",
      //   image:
      //     "data:image/png;base64,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",
      // },
      // {
      //   name: "Flutter",
      //   image:
      //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      // },
      //   ],
      // },
      // {
      //   title: "Backend",
      //   skills: [
      {
        name: "Node Js",
        image: "https://icon.icepanel.io/Technology/svg/Node.js.svg",
      },
      // {
      //   name: "Python",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      // },
      {
        name: "PostgreSQL",
        image: "https://icon.icepanel.io/Technology/svg/PostgresSQL.svg",
      },
      {
        name: "MongoDB",
        image: "https://icon.icepanel.io/Technology/svg/MongoDB.svg",
      },
      // {
      //   name: "Firebase",
      //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      // },
      //   ],
      // },
      // {
      //   title: "DevOps",
      //   skills: [
      {
        name: "Docker",
        image: "https://icon.icepanel.io/Technology/svg/Docker.svg",
      },
      // {
      //   name: "AWS S3",
      //   image:
      //     "https://icon.icepanel.io/Technology/png-shadow-512/AWS.png",
      // },
      // {
      //   name: "Google Cloud",
      //   image:
      //     "https://icon.icepanel.io/Technology/svg/Google-Cloud.svg",
      // },
      {
        name: "Elasticsearch",
        image:
          "https://icon.icepanel.io/Technology/png-shadow-512/Elastic-Search.png",
      },
      // {
      //   name: "Logstash",
      //   image:
      //     "https://icon.icepanel.io/Technology/svg/Logstash.svg",
      // },
      // {
      //   name: "Kibana",
      //   image:
      //     "https://icon.icepanel.io/Technology/svg/Kibana.svg",
      // },
      //   ],
      // },
      // {
      //   title: "Programming Languages",
      //   skills: [
      {
        name: "C++",
        image:
          "https://icon.icepanel.io/Technology/svg/C%2B%2B-%28CPlusPlus%29.svg",
      },
      {
        name: "Python",
        image: "https://icon.icepanel.io/Technology/svg/Python.svg",
      },
      //   ],
      // },
      // {
      //   title: "Tools",
      //   skills: [
      {
        name: "Git",
        image: "https://icon.icepanel.io/Technology/svg/Git.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      // {
      //   name: "Jira",
      //   image:
      //     "https://icon.icepanel.io/Technology/svg/Jira.svg",
      // },
      // {
      //   name: "Bitbucket",
      //   image:
      //     "https://icon.icepanel.io/Technology/svg/BitBucket.svg",
      // },
      // {
      //   name: "VS Code",
      //   image:
      //     "https://icon.icepanel.io/Technology/svg/Visual-Studio-Code-%28VS-Code%29.svg",
      // },
      // {
      //   name: "Postman",
      //   image:
      //     "https://icon.icepanel.io/Technology/svg/Postman.svg",
      // },
      //   ],
      // },
      // {
      //   title: "Fundamentals",
      //   skills: [
      {
        name: "Data Structures",
        image:
          "https://cdn1.iconfinder.com/data/icons/business-bicolor-3/512/social_graph-512.png",
      },
      {
        name: "Algorithms",
        image: "https://icon.icepanel.io/Technology/svg/The-Algorithms.svg",
      },
      {
        name: "Object Oriented Programming",
        image: "https://cdn-icons-png.freepik.com/512/9875/9875545.png",
      },
      {
        name: "Operating Systems",
        image: "https://icon.icepanel.io/Technology/png-shadow-512/Linux.png",
      },
      {
        name: "Database Management System",
        image: "https://icon.icepanel.io/Technology/svg/SQL-Developer.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 3,
    img: "https://cdn.brandfetch.io/idfo-ApodL/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1667944505736",
    role: "Software Developer Engineer I",
    company: "eClinicalWorks",
    date: "Jan 2025 - Present",
    desc: (
      <ul>
        <li>
          Developed and enhanced core EHR backend services for scheduling,
          clinical documentation, lab orders, and e-prescriptions, implementing
          RESTful APIs in Java with strong data validation and consistency.
        </li>
        <li>
          Built a resource scheduling system and clinical documentation
          workflows, enabling efficient appointment management, progress note
          recording, lab requests, and medication prescribing while ensuring
          secure data handling.
        </li>
        <li>
          Integrated lab and e-prescription pipelines and contributed to an
          AI-driven no-show prediction feature, collaborating with product, QA,
          and clinical teams to deliver features aligned with real-world
          healthcare workflows.
        </li>
      </ul>
    ),
    skills: ["Java", "Spring Boot", "MySQL", "Microservices", "Cloud"],
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRMxyvgv3E-mk7xdh_iSxO-aaze5krs0EDkJ6lcgfZWlg&s",
    role: "Software Engineer",
    company: "Crest Data",
    date: "June 2024 - Jan 2025",
    desc: (
      <ul>
        <li>
          Contributed to a project to develop Elasticsearch data connectors to
          centralize and index data from multiple platforms, improving search
          efficiency by 40%, achieving 100% controlled data access and enhanced
          development workflows through a searchable and controlled platform.
        </li>
        <li>
          Engineered and implemented an automation tool to seamlessly migrate
          Splunk monitoring and logging data, visualizations, alerts, and
          queries to Datadog.
        </li>
        <li>
          Contributed to developing a solution that simplifies the transition to
          Datadog’s advanced observability platform, reducing complexity and
          risk.
        </li>
      </ul>
    ),
    skills: ["Docker", "Kafka", "Python", "Elasticsearch", "Spring Boot"],
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRMxyvgv3E-mk7xdh_iSxO-aaze5krs0EDkJ6lcgfZWlg&s",
    role: "Software Engineer Intern",
    company: "Crest Data",
    date: "Dec 2023 - May 2024",
    desc: (
      <ul>
        <li>
          Developed a novel Bitbucket connector for Elasticsearch, enhancing
          search capabilities by indexing data from Bitbucket. Gained hands-on
          experience in SDLC, Agile methodologies, and development workflow
        </li>
      </ul>
    ),
    skills: ["Docker", "AWS", "Python", "Elasticsearch", "Spring Boot"],
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbrpc-YSRNb8opSkAWej0DjHCL2REOmAuGNnBxx9CFBw&s",
    role: "Summer Research Assistant",
    company: "DA-IICT",
    date: "May 2023 - July 2023",
    desc: "Added some good features and improvements to the existing library management system of university  .",
    skills: ["ReactJS", "NodeJs", "Material UI", "HTML", "CSS", "JavaScript"],
    doc: "",
  },
  // {
  //   id: 0,
  //   img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbrpc-YSRNb8opSkAWej0DjHCL2REOmAuGNnBxx9CFBw&s",
  //   role: "Full Stack Developer",
  //   company: "Placement Cell of DA-IICT",
  //   date: "Sept 2022 - Dec 2022",
  //   desc: "Added features to the web application and improved user experience for the existing placement portal.",
  //   skills: ["React", "NodeJs", "JavaScript"],
  //   doc: "",
  // },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbrpc-YSRNb8opSkAWej0DjHCL2REOmAuGNnBxx9CFBw&s",
    school:
      "Dhirubhai Ambani Institute of Information & Communication Technology, Gandhinagar",
    date: "2020 - 2024",
    grade: "7.08 CGPA",
    desc: "I have completed my Bachelor's degree in Information & Communication Technology at DA-IICT, Gandhinagar. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree:
      "Bachelor of Technology - BTech, Information & Communication Technology",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRarFn2taiFXIFW4Q971bJXjCyGwL260o7JrdNjutdWQg&s",
    school: "Shri BAPS Swaminarayan Vidyamandir",
    date: "2018 - 2020",
    grade: "90%",
    desc: "I completed my class 12 high school education at Shri BAPS Swaminarayan Vidyamandir, where I studied PCM with Computer Science.",
    degree: "GSEB(XII), PCM with Computer",
  },
];

export const projects = [
  {
    id: 1,
    title: "Resumify",
    date: "",
    description:
      "Resumify simplifies the resume creation process with advanced web technologies, allowing users to easily generate a polished PDF resume by filling out a simple form. Now enhanced with an AI-powered Resume Roaster, this tool goes beyond creation – it analyzes and critiques uploaded resumes, offering personalized feedback to help you stand out. Whether you're building a new resume or refining an existing one, Resumify ensures your resume is both professional and impactful.",
    image: "image.png",
    tags: ["React", "Node Js", "Python"],
    category: "web app",
    github: "https://github.com/swa-aham/Resumify",
    webapp: "https://resumify-black.vercel.app/",
  },
  {
    id: 1,
    title: "Research Assistant",
    date: "",
    description:
      "This is a Chrome extension that combines text summarization and note-taking to enhance research efficiency. The tool allows users to quickly condense lengthy content and capture key insights, streamlining the process of gathering and organizing information for easy reference.",
    // image: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d8/76/1a/d8761a8a-e251-0867-1743-7189846f3f5d/AppIcon-1x_U007ephone-0-85-220-0.png/512x512bb.jpg",
    image:
      "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/7f/6c/38/7f6c3835-1202-52f2-1440-4bdca7432c74/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/512x512bb.jpg",
    tags: ["Java", "Spring Boot", "JS", "Gemini-Flash"],
    category: "web app",
    github: "https://github.com/swa-aham/Research-Assistant-Extension",
    webapp: "",
  },
  {
    id: 9,
    title: "Next GPT",
    date: "",
    description:
      "Developed a scalable and secure custom GPT model using Next.js, and TypeScript. Leveraged Gemini API to provide advanced language capabilities and integrated Clerk for robust authentication, enabling up to 10,000 daily logins. This project demonstrates expertise in AI model development, backend engineering, and user authentication.",
    image: "https://i.imghippo.com/files/qSmBW1725747436.png",
    tags: ["Typescript", "Next.js", "Gemini"],
    category: "web app",
    github: "https://github.com/swa-aham/Next-GPT",
    webapp: "https://next-gpt-mu.vercel.app/",
  },
  // {
  //   id: 0,
  //   title: "Builder.io",
  //   date: "",
  //   description:
  //     "The Automated Resume Builder project simplifies the process of creating professional resumes. Utilizing cutting-edge web technologies, this tool allows users to fill out a single form and automatically generates a polished PDF resume.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
  //   tags: ["React Js", "MongoDb", "Node Js", "Express Js"],
  //   category: "web app",
  //   github: "",
  //   webapp: "",
  //   member: [
  //     {
  //       name: "",
  //       img: "",
  //       linkedin: "",
  //       github: "",
  //     },
  //     {
  //       name: "",
  //       img: "",
  //       linkedin: "",
  //       github: "",
  //     },
  //   ],
  // },
  // {
  //   id: 2,
  //   title: "Brain Tumor Detection",
  //   date: "Jan 2023 - Mar 2023",
  //   description:
  //     "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
  //   image:
  //     "",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "",
  //   webapp: "",
  //   member: [
  //     {
  //       name: "",
  //       img: "",
  //       linkedin: "",
  //       github: "",
  //     },
  //     {
  //       name: "",
  //       img: "",
  //       linkedin: "",
  //       github: "",
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   title: "Buckoid",
  //   date: "Dec 2021 - Apr 2022",
  //   description:
  //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
  //   image:
  //     "",
  //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
  //   category: "android app",
  //   github: "",
  //   webapp: "",
  // },
  {
    id: 10,
    title: "Employee Management App",
    date: "",
    description:
      "Employee Management System: Manage employee data (add, view, edit, delete) in a user-friendly terminal interface. Simplifies HR tasks and keeps employee information organized. Built with Python for easy use and customization.",
    image:
      "https://blog.vantagecircle.com/content/images/size/w1000/2021/01/Employee-Management-Meaning-Importance-Tips-Tools---More.png",
    tags: ["Python"],
    category: "",
    github: "https://github.com/swa-aham/Employee-Management-System",
    webapp: "https://github.com/swa-aham/Employee-Management-System",
  },
  {
    id: 4,
    title: "Elastic Search Connector",
    date: "",
    description:
      "The Bitbucket to Elasticsearch Connector project facilitates seamless data integration between the Bitbucket platform and Elasticsearch, enabling efficient and comprehensive search capabilities. This connector retrieves data from the Bitbucket API—including repositories, commits, pull requests, issues, and other relevant information—then processes and transforms it into a format suitable for Elasticsearch ingestion. By indexing this data in Elasticsearch, the project enhances its accessibility and searchability, allowing users to leverage Elasticsearch's powerful query and aggregation features for deep insights and improved data management. This tool is invaluable for developers, project managers, and analysts needing quick and efficient access to Bitbucket data.",
    image: "https://i.imghippo.com/files/3I3fI1718820000.png",
    tags: ["Elasticsearch", "Python", "Bitbucket API", ""],
    category: "",
    github: "https://github.com/swa-aham/Elastic-Search-Connector",
    webapp: "https://github.com/swa-aham/Elastic-Search-Connector",
  },
  {
    id: 6,
    title: "The Wall Street",
    date: "",
    description:
      "The Stock Price Prediction project leverages machine learning to forecast future stock prices, providing valuable insights for investors and analysts. By collecting and preprocessing historical stock data and financial indicators, the project utilizes advanced algorithms such as linear regression, decision trees, and neural networks to build predictive models. These models are trained and evaluated using metrics like mean absolute error (MAE) and root mean square error (RMSE) to ensure accuracy. The predicted prices are then visualized through interactive charts, enabling users to make informed investment decisions and better understand market trends.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcyKynHXI0K2lxLd9e7tckMV0ZZba7n6tLlw&s",
    tags: ["Python", "Pandas", "Numpy", "Machine Learning"],
    category: "web app",
    github: "",
    webapp: "",
  },
  {
    id: 7,
    title: "Shrink Me",
    date: "",
    description:
      "Introducing Shrink Me, The URL Shortener, the simplest, streamlined and efficient tool built with HTML, CSS, and JavaScript. Our URL Shortener designed to simplify your online experience. This project allows users to convert long, cumbersome URLs into concise, easy-to-share links, improving both accessibility and aesthetics in communications. The clean and intuitive HTML interface makes it user-friendly and accessible for everyone. Whether you're looking to share links on social media, through email, or for any other purpose, our URL Shortener provides a quick, reliable, and hassle-free solution.",
    image:
      "https://static1.makeuseofimages.com/wordpress/wp-content/uploads/2022/01/url-shortener.jpg?q=50&fit=contain&w=1140&h=&dpr=1.5",
    tags: ["JavaScript", "CSS", "HTML"],
    category: "",
    github: "https://github.com/swa-aham/URL-Shortner",
    webapp: "https://url-shortner-chi-drab.vercel.app/",
  },
  {
    id: 8,
    title: "AutoDine",
    date: "",
    description:
      "Introducing AutoDine, a revolutionary restaurant automation system built from the ground up for efficiency and ease of use. This full-stack project utilizes the power of JavaScript, HTML, CSS, and MongoDB to streamline your entire operation. From online ordering and table reservations to real-time kitchen management and insightful reporting, AutoDine empowers your restaurant to flourish in today's fast-paced digital world.",
    image:
      "https://as1.ftcdn.net/v2/jpg/02/52/38/80/1000_F_252388016_KjPnB9vglSCuUJAumCDNbmMzGdzPAucK.jpg",
    tags: ["MongoDB", "JavaScript", "CSS", "React"],
    category: "machine learning",
    github: "https://github.com/swa-aham/Restaurant-Automation-System",
    webapp: "https://github.com/swa-aham/Restaurant-Automation-System",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
